import React, { PropTypes } from 'react';
import _get from 'lodash/get';

import { NitroText } from 'nitro-components';

import {
  FooterContainer,
  Links,
  LogoLinks,
  FooterLinks,
  LogoLink,
  LinksWrapper
} from './style';

const openLink = url => {
  window.open(`${url}`, '_blank');
};

const termsLink = [
  {
    chl: 'Terms of Use',
    url: _get(window.ORGBranding, 'defaultBrand.legal.termsAndConditionsLink')
  },
  {
    chl: 'Privacy policy',
    url: _get(window.ORGBranding, 'defaultBrand.legal.privacyPolicyLink')
  }
  // {
  //   chl: 'Policy Document',
  //   url: ''
  // }
];

const Footer = ({ variant }) => (
  <FooterContainer variant={variant}>
    <p>
      {_get(window.ORGBranding, 'defaultBrand.legal.rightsReservedLong')}
    </p>
    <LinksWrapper>
      <NitroText size="4" variant="base3" align="center">
        <Links>
          {termsLink.map(e => (
            <FooterLinks onClick={() => openLink(e.url)} key={e.url}>
              {e.chl}
            </FooterLinks>
          ))}
        </Links>
      </NitroText>
    </LinksWrapper>
  </FooterContainer>
);

Footer.propTypes = {
  variant: PropTypes.string
};

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/footer/Footer.js